<script>
    import Spinner from 'svelte-spinner';

    let size = 50;
    let speed = 750;
    let color = 'red';
    let thickness = 2.0;
    let gap = 40;
</script>

<div class="text-center">
    <Spinner
            size="{size}"
            speed="{speed}"
            color="{color}"
            thickness="{thickness}"
            gap="{gap}"
    />
</div>